import React, { useContext, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { IWorkorder } from "../../../../app/models/workorder";
import WorkOrderStore from "../../../../app/stores/workorderStore";
import { observer } from "mobx-react-lite";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";

interface IProps {
  workorders: IWorkorder[];
}


const WorkOrderGrid: React.FC<IProps> = props => {
  const [gridApi,setGridApi] = useState(null);

  const workorderStore = useContext(WorkOrderStore);
  const { selectWorkOrder } = workorderStore;
  
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 

    
  const GetSelectedRow = (params: any) => {
    if (params.node.selected === true) {
      var JobId: string = params.node.data.JobId;

      //Pass this to store
      selectWorkOrder(JobId, sessionObj.User.Username);
    }
  };
  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
    setGridApi(params.api)
    
    
}
let columnset = [
  {
    headerName: "Client Ref",
    field: "ClientRef",
    width: 150,
    filter:true,
    suppressMenu:true
  },

  { headerName: "Job No", field: "JobNo", width: 150,filter:true,suppressMenu:true},
  //{ headerName: "Job Substatus", field: "JobSubStatus",filter:true,suppressMenu:true},
  {
    headerName: "Raised Date-",
    field: "DateRaised",
    type: "dateColumn",
    sort: "desc",
    valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true
  },   
  {
    headerName: "Target Date",
    field: "TargetDate",
    type: "dateColumn",
    valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true
    
  },
  { headerName: "Job Value", field: "JobValue", valueFormatter: currencyFormatter,filter:true,suppressMenu:true }
]
if(sessionObj.Client.Name == "Red Kite Housing"){
  columnset = [
    {
      headerName: "Client Ref",
      field: "ClientRef",
      width: 150,
      filter:true,
      suppressMenu:true
    },
  
    { headerName: "Job No", field: "JobNo", width: 150,filter:true,suppressMenu:true},
    //{ headerName: "Job Substatus", field: "JobSubStatus",filter:true,suppressMenu:true},
    {
      headerName: "Raised Date",
      field: "DateRaised",
      type: "dateColumn",
      sort: "desc",
      valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true
    },   
    {
      headerName: "Workstream",
      field: "Priority",
      type: "dateColumn",
      valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true
      
    },
    {
      headerName: "VO Requested",
      field: "VORequestedDate",
      type: "dateColumn",
      valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true
      
    },
    { headerName: "VO Value", field: "VariationValue", valueFormatter: currencyFormatter,filter:true,suppressMenu:true }
  ]
}


function exportCSV(){
  gridApi.exportDataAsCsv()
}

function exportSelectedAsCsv(){
  gridApi.exportDataAsCsv({onlySelected:true});
}



  return (
    <div className="table-responsive">
      <div
        className="ag-theme-material"
        style={{ height: "400px", width: "auto" }}
      > 
      <div>
      <button onClick={exportCSV}>Export All</button>
         <button onClick={exportSelectedAsCsv}>Export Selected</button>
      </div>
        <AgGridReact
          enableSorting={true}
          enableColResize={true}
          rowSelection={"single"}
          onGridReady={onGridReady}
          pagination={true}
          floatingFilter={true}
          onRowSelected={GetSelectedRow}
          //suppressPaginationPanel={true}
          //rowModelType={"infinite"}
          columnDefs={columnset}
          rowData={props.workorders}
          
        ></AgGridReact>
      </div>
      
    </div>
  );
};



function dateFormatter(params:any) {
  var date = new Date(params.value);
  return date.toLocaleString();
}

function dateFormatterNoDaylight(params:any) {
  if(params.value){
    var formatdate = (params.value).replace("T", " ").replace("Z", "");
    return formatdate.toString();
  }
  else{
    return (params.value);
  }
}


function currencyFormatter(params:any) {
  return "\xA3" + params.value.toFixed(2);
}

export function currentPage () {


}



export default observer(WorkOrderGrid);
